import { createContext } from 'react';

export const ChartContext = createContext(null);



// WEBPACK FOOTER //
// ./src/components/common/Charts/context/index.js